export default "__VITE_ASSET__ccb91fbd__"